import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'sub-footer',
  templateUrl: './sub-footer.component.html'
})
export class SubFooterComponent implements OnInit {

  currentYear: string;

  constructor() {
  }

  ngOnInit() {
    this.currentYear = (new Date()).getFullYear().toString();
  }

}
